module.exports = __webpack_public_path__ + "images/349a2ddcc5348f25d2b352096a595d69.jpg";